import { GET_PRODUCTION_PLAN_INPUTS } from './constants';

export const getProductionPlanInputs = () => ({
  type: GET_PRODUCTION_PLAN_INPUTS,
});
